import { extensions } from '../extensions/Extensions';
import { PrepareSystem } from './PrepareSystem';

extensions.add(PrepareSystem);
